import { ConcreteEncodable } from "./ConcreteEncodable";

import { GammaOrderLifeCycleEventImplEncoder } from "../../encoder/GammaOrderLifeCycleEventImplEncoder";

import * as CubiqTS from "../../index";
import { GammaOrderLifeCycleEvent } from "../GammaOrderLifeCycleEvent";

export class GammaOrderLifeCycleEventImpl
  extends ConcreteEncodable
  implements GammaOrderLifeCycleEvent
{
  public static enType: string = "com.bcdfx.model.event.lifecycle.GammaOrderLifeCycleEventImpl";

  /*FID=1*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=2*/
  public eventList: Array<CubiqTS.OrderLifeCycleEvent> | null = null;
  /*FID=4*/
  public eventTypeId: CubiqTS.FxLifeCycleEventType;
  /*FID=5*/
  public externalClientReference: string;
  /*FID=6*/
  public id: string;
  /*FID=7*/
  public linkReference: string;
  /*FID=8*/
  public strategyOrderState: Array<CubiqTS.StrategyComponentState> | null = null;
  /*FID=9*/
  public targetUserCode: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = GammaOrderLifeCycleEventImplEncoder.Instance;
    this.setEncodableType(GammaOrderLifeCycleEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "GammaOrderLifeCycleEventImpl[" +
      "errors=" +
      this.errors +
      "eventList=" +
      this.eventList +
      "eventTypeId=" +
      this.eventTypeId +
      "externalClientReference=" +
      this.externalClientReference +
      "id=" +
      this.id +
      "linkReference=" +
      this.linkReference +
      "strategyOrderState=" +
      this.strategyOrderState +
      "targetUserCode=" +
      this.targetUserCode +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
